/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {DatepickerHelperService} from '../../../../shared/utils/datepicker-helper/datepicker-helper.service';
import {UserBaseContract} from '../../../../bundles/api/contracts/user-base.contract';
import {PrettyPrintClosedByPipe} from '../../../../bundles/shared/pipes/pretty-closed-by/pretty-print-closed-by.pipe';

export function dateFullFormatPipe(cellValue: number): string {
    let value = '-';
    if (cellValue != null) {
        value = DatepickerHelperService.convertTimestampToDateAndTime(cellValue);
    }
    return value;
}

export function dateSimpleFormatUTCPipe(cellValue: number): string {
    let value = '-';
    if (cellValue != null) {
        value = DatepickerHelperService.convertTimestampToDateAndTime(cellValue, 'Etc/UTC','DD-MM-YYYY' );
    }
    return value;
}

export function userPipe(cellValue: UserBaseContract): string {
    let displayValue = '-';
    if (cellValue != null) {
        displayValue = (new PrettyPrintClosedByPipe())
            .transform(cellValue);
    }
    return displayValue;
}

export function statusPipe(cellValue: boolean): string {
    let displayValue = '-';
    displayValue = cellValue === true ? 'Active' : 'Inactive';
    return displayValue;
}
